var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.title},[_vm._t("title")],2),_c('div',{class:_vm.$style.content},[(_vm.isLoading)?_c('Loader'):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }